/**
 * ARIA Brief API — send-to-me + preview + staging config (PR8).
 */
import { apiFetch } from './client'

export type BriefConfig = {
  canOverrideRecipient: boolean
  allowlist: string[]
}

export async function fetchAriaBriefConfig() {
  return apiFetch<{ data: BriefConfig }>('GET', '/api/aria/brief/config')
}

export async function sendAriaBrief(
  briefKind: 'tuesday' | 'friday' = 'tuesday',
  opts?: { to?: string },
) {
  const body: { briefKind: string; to?: string } = { briefKind }
  if (opts?.to?.trim()) body.to = opts.to.trim()
  return apiFetch<{ data: { sent: boolean; inbox: boolean; subject: string; storyLead: string; recipient?: string; warning?: string | null }; message?: string }>(
    'POST',
    '/api/aria/brief/send-me',
    body,
  )
}

export async function previewAriaBrief(briefKind: 'tuesday' | 'friday' = 'tuesday') {
  return apiFetch<{ data: Record<string, unknown> }>(
    'GET',
    `/api/aria/brief/preview?briefKind=${briefKind}`,
  )
}
